import { ReactNode } from 'react'

import { Skeleton, TableCell, TableRow } from '@mui/material'

import type { Column } from '../TableBase.types'

type Props<Data extends Record<string, unknown>, SortAttribute extends string> = {
  columns: Column<Data, SortAttribute>[]
  rowCount: number
  withCheckboxes?: boolean
  rowActions?: ReactNode
  checkColumnVisibility: (column: string | Column<Data, SortAttribute>) => boolean
}

export const LoadingSkeleton = <
  Data extends Record<string, unknown>,
  SortAttribute extends string
>({
  columns,
  rowCount,
  withCheckboxes,
  rowActions,
  checkColumnVisibility
}: Props<Data, SortAttribute>) => {
  return (
    <>
      {Array(rowCount)
        .fill(0)
        .map((_, index) => (
          <TableRow
            key={`skeleton-${index}`}
            sx={{
              '& > :first-of-type': {
                pl: withCheckboxes ? 1 : 2.25
              },
              '& > :nth-of-type(2)': {
                pl: withCheckboxes ? 1.25 : undefined
              },
              '& > :last-child': {
                pr: 1.7
              }
            }}
          >
            {withCheckboxes && (
              <TableCell padding="checkbox" sx={{ pr: 0.2 }}>
                <Skeleton
                  variant="rectangular"
                  width={18}
                  height={18}
                  sx={{ borderRadius: 0.75, mx: 'auto' }}
                />
              </TableCell>
            )}

            {columns
              .filter((column) => checkColumnVisibility(column.id))
              .map((column) => (
                <TableCell key={String(column.id)} align={column.align}>
                  <Skeleton
                    variant="text"
                    width={`${Math.floor(Math.random() * 80) + 20}%`}
                    height={18}
                    sx={{ borderRadius: 0.75 }}
                  />
                </TableCell>
              ))}

            {rowActions && (
              <TableCell align="right" padding="none" sx={{ pr: 1.15, py: 0.3 }}>
                <Skeleton variant="circular" width={26} height={26} sx={{ ml: 'auto' }} />
              </TableCell>
            )}
          </TableRow>
        ))}
    </>
  )
}
